import React, {useState} from "react";
import {Col, Container} from "reactstrap";
import {to2Decimals} from "./utils";

export const Deducibles = ({ deducible, space }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    let { total, saldo, consumido, desc } = deducible;
    let space1 = space;
    let mensaje = "";
    let percent = 100 - (saldo / total) * 100;
    percent = percent.toFixed(2);

    total = to2Decimals(total);
    saldo = to2Decimals(saldo);

    if (total < -1) {
        mensaje = `Deducible año póliza no definido correctamente!`;
    } else if (total < 0) {
        mensaje = `No se encuentra deducible año póliza.`;
    } else {
        if (saldo < 1) {
            mensaje = `Tu deducible de $${total} por ${desc} ha sido cubierto en su totalidad`;
        } else if (saldo === total) {
            mensaje = `Todavía no has cubierto tu deducible de $${total} por ${desc}`;
        } else {
            mensaje = `Te falta $${saldo} para terminar de cubrir tu deducible $${total} por ${desc}`;
        }
    }

    return (
        <Container className="text-center">
            {!space1 && (
                <>
                    <br />
                    <br />
                    <Col sm={6} />
                </>
            )}
            <Col sm={!space1 ? 6 : 12}>
                <small>{mensaje}</small>
                <br />
                {total > 0 && (
                    <div className="d-flex barra-deducible">
                        <div className="w3-light-grey flex-grow-1 d-flex">
                            {percent * 1 > 1 && (
                                <div
                                    className="w3-container w3-green text-center"
                                    style={{ width: percent + "%", minWidth: percent + "%" }}
                                >
                                    <div className={"d-flex justify-content-center align-items-center"}>
                                        {formatMoney(consumido)}
                                    </div>
                                </div>
                            )}

                            <div className={"deducible w-100"}>
                                <div className={"d-flex justify-content-center align-items-center"}>
                                    {formatMoney(saldo)}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <br />
            </Col>
        </Container>
    );
};

export function formatMoney(value) {
    const parsedValue = parseFloat(value).toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
    return isNaN(parsedValue) ? "-" : "$" + parsedValue;
}
